// En producción, nginx reverse-proxea /api/* al backend.
// Usamos string vacío para same-origin — el navegador apunta al mismo host:puerto de nginx.
const API_BASE = "";

interface RequestOptions {
  method?: string;
  body?: unknown;
  headers?: Record<string, string>;
  params?: Record<string, string | number | boolean | undefined>;
}

// Backend wraps all responses in { code, status, message, data }
// This helper auto-unwraps so frontend gets the inner data directly
function unwrapEnvelope<T>(raw: unknown): T {
  if (raw && typeof raw === "object") {
    const obj = raw as Record<string, unknown>;
    // If it has code, status, message AND data fields, return data
    if ("code" in obj && "status" in obj && "message" in obj && "data" in obj) {
      return obj.data as T;
    }
  }
  return raw as T;
}

export async function apiRequest<T>(endpoint: string, options: RequestOptions = {}): Promise<T> {
  const { method = "GET", body, headers = {}, params } = options;

  let url = `${API_BASE}${endpoint}`;

  if (params) {
    const searchParams = new URLSearchParams();
    for (const [key, value] of Object.entries(params)) {
      if (value !== undefined && value !== null) {
        searchParams.append(key, String(value));
      }
    }
    const qs = searchParams.toString();
    if (qs) url += `?${qs}`;
  }

  const token = localStorage.getItem("access_token");
  const requestHeaders: Record<string, string> = {
    "Content-Type": "application/json",
    ...headers,
  };

  if (token) {
    requestHeaders["Authorization"] = `Bearer ${token}`;
  }

  const response = await fetch(url, {
    method,
    headers: requestHeaders,
    body: body ? JSON.stringify(body) : undefined,
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({ message: "Error en la solicitud" }));
    throw new Error(errorData.message || `HTTP ${response.status}`);
  }

  const rawData = await response.json();
  // Auto-unwrap envelope: { code, status, message, data } -> data
  return unwrapEnvelope<T>(rawData);
}